import { render, staticRenderFns } from "./ModalFinalizar.vue?vue&type=template&id=b8231942"
import script from "./ModalFinalizar.vue?vue&type=script&lang=js"
export * from "./ModalFinalizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports